import React, { useState } from 'react';
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import login from '../../assets/video/login.mp4';
import registeraccount from '../../assets/video/registeraccount.mp4';
import forgotpassword from '../../assets/video/forgotpassword.mp4';
import addproject from '../../assets/video/addproject.mp4';
import addmilestone from '../../assets/video/addmilestone.mp4';
// import addtaskgroup from '../../assets/video/addtaskgroup.mp4';
import addtask from '../../assets/video/addtask.mp4';
import personalsetting from '../../assets/video/personalsetting.mp4';
import portaluser from '../../assets/video/portaluser.mp4';
import addcompany from '../../assets/video/addcompany.mp4';
import addbu from '../../assets/video/addbu.mp4';
import adddepartment from '../../assets/video/adddepartment.mp4';
import projectWiseLogo from '../../assets/images/pw-logo-white.png';
import Faqimg from '../../assets/images/faqimag.jpg';
import { NavLink } from 'reactstrap';

function Faq() {
      const [productisOpen1, productsetIsOpen1] = useState(1);

      const toggleSection = (sectionNumber) => {
        productsetIsOpen1(productisOpen1 === sectionNumber ? 0 : sectionNumber);
      };
      const faqData = [
            { question: "How To Login Your Account?", videoSrc: login },
            { question: "How To Register Your Account?", videoSrc: registeraccount },
            { question: "How To Set New Password Using Forgot Password?", videoSrc: forgotpassword },
            { question: "How To Add Project?", videoSrc: addproject},
            { question: "How To Add Milestone?", videoSrc: addmilestone},
            // { question: "How To Add Task Group?", videoSrc: addtaskgroup },
            { question: "How To Add Task?", videoSrc:  addtask },
            { question: "How To Change Personal Information & Password?", videoSrc: personalsetting  },
            { question: "How To Add Portal/Client Users?", videoSrc: portaluser },
            { question: "How To Add Company?", videoSrc: addcompany },
            { question: "How To Add Bussiness Unit?", videoSrc: addbu },
            { question: "How To Add Department?", videoSrc: adddepartment},

            // ... Add other FAQ data entries
          ];
  return (
    <>
       <div  id="faq-sec" className="Almuni ">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="login-img">
                                <div className="loginvedio">
                                    {/* <video playsInline="playsInline" autoPlay="autoplay" muted="muted" loop="loop">
                                        <source src={loginVideo} type="video/mp4" />
                                    </video> */}
                                    <img src={Faqimg} alt="Login Images" />
                                </div>
                                {/* <img src="./images/alum.png"/> */}
                                <div className="mask" >
                                    <div className="mask-in">
                                        {/* <p>ProjectWise</p> */}
                                        <img src={projectWiseLogo} alt="ProjectWise Management Software" />
                                        <h1>Frequently Asked Questions</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                  <div className="col-lg-8 col-md-6">
                        <div id="faq-wrap">
                            <h4>FAQs</h4>
                        {faqData.map((faq, index) => (
                        <div className="faq-main" key={index}>
                              <div className="dropdown">
                              {productisOpen1 === index + 1 ? (
                              <FaChevronDown onClick={() => toggleSection(index + 1)} />
                              ) : (
                              <FaChevronRight onClick={() => toggleSection(index + 1)} />
                              )}
                              <span>{faq.question}</span>
                              </div>
                              <div className={productisOpen1 === index + 1 ? "productlist-open" : "product-list"}>
                              <div className="projectwisedetail-wrap">
                              <NavLink to={faq.videoLink}>
                                    <video width="600" controls>
                                    <source src={faq.videoSrc} type="video/mp4" />
                                    </video>


                              </NavLink>
                              </div>
                              </div>
                        </div>
                        ))}
                        </div>
                  </div>
                </div>
      </div>
                  </div>
                  
    {/* <div id="faq-wrap"> 
    <div className='wrapper'>
            <div className="content">
            <div className='contentInnerWrap'>
                        <div className='faq-whitebox'>
                              <h4> FAQs</h4>
                              <div className='faq-main '>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 1 : 0)}/>        
                                          <span>How to login ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 1 ? "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>                 
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={login} type="video/mp4" />                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main '>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 2 : 0)}/>        
                                          <span>How to Register ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 2 ? "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>                   
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={registeraccount} type="video/mp4" />                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div>   
                              <div className='faq-main '>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 3 : 0)}/>        
                                          <span>How to Forgot Password ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 3 ? "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>                   
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={forgotpassword} type="video/mp4" />                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div>  
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 4 : 0)}/>        
                                          <span>How to Add a Project ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 4 ? "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addproject} type="video/mp4" />                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 5 : 0)}/>        
                                          <span>How to Add a Milestone ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 5 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addmilestone} type="video/mp4" />                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 6 : 0)}/>        
                                          <span>How to Add a Task Group ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 6 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addtaskgroup} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 7 : 0)}/>        
                                          <span>How to Add a Task ?</span>
                                    </div> 
                                    <div className ={productisOpen1 === 7 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addtask} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 8 : 0)}/>        
                                          <span>How to add Personal Information & change  Password</span>
                                    </div> 
                                    <div className ={productisOpen1 === 8 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={personalsetting} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 9 : 0)}/>        
                                          <span>How to add a Portal /Client User</span>
                                    </div> 
                                    <div className ={productisOpen1 === 9 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={portaluser} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 10 : 0)}/>        
                                          <span>How to add a Company</span>
                                    </div> 
                                    <div className ={productisOpen1 === 10 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addcompany} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 11 : 0)}/>        
                                          <span>How to add a  BU</span>
                                    </div> 
                                    <div className ={productisOpen1 === 11 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={addbu} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                              <div className='faq-main'>
                                    <div className="dropdown">
                                          <FaChevronDown  onClick={() => productsetIsOpen1(productisOpen1=== 0 ? 12 :0)}/>        
                                          <span>How to add a Department</span>
                                    </div> 
                                    <div className ={productisOpen1 === 12 ?  "productlist-open "  : " product-list"}>
                                          <div className='projectwisedetail-wrap'>      
                                                <NavLink> 
                                                <video width="600" controls>
                                                      <source src={adddepartment} type="video/mp4"/>                 
                                                </video>
                                                </NavLink>
                                          </div>
                                    </div> 
                              </div> 
                        </div>
                        </div>
            </div>
    </div>
    </div> */}
    </>
  )

}

export default Faq